import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    checkedCategory:[],
    searchKey:''
};

const projectFilterSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        setcheckedCategory: (state, action) => {

         
          return  state ={...state,checkedCategory:action.payload}
        },
        setSearchKey: (state, action) => {

         
            return  state ={...state,searchKey:action.payload}

        },
    },
});

export const {setcheckedCategory,setSearchKey} = projectFilterSlice.actions;
export default projectFilterSlice.reducer;
